var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1511,
    height: 512,
    viewBox: "0 0 1511 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125 99.9361H322.639V155.857H183.884V231.9H308.647V287.821H183.884V413H125V99.9361Z",
    fill: "#69EBD0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M375.109 99.9361H433.993V356.728H565.752V412.649H375.109V99.9361Z",
    fill: "#69EBD0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M701.592 99.9361H769.221L886.405 412.883H821.691L795.573 338.01H676.056L649.938 412.883H585.224L701.592 99.9361ZM776.217 283.61L735.756 167.205L694.829 283.61H776.217Z",
    fill: "#69EBD0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M844.804 99H912.433L1029.62 411.947H964.904L938.785 337.074H819.269L793.15 411.947H728.437L844.804 99ZM919.429 282.674L878.968 166.269L838.042 282.674H919.429Z",
    fill: "#2A9DF4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.35 99H1142.14L1226.67 318.94L1311.21 99H1387.58V411.947H1329.28V206.045L1249.99 411.947H1204.29L1124.41 206.045V411.947H1066.52L1066.35 99Z",
    fill: "#2A9DF4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.05f119ae6128ce668927ffdb5bec46ee.svg";
export { ForwardRef as ReactComponent };